export const titleLogin = 'Login | Angellira';
export const titleAccess = 'Grant | Angellira';
export const titleRecover = 'Recover | Angellira';
export const titleInpersonate = 'Inpersonate | Angellira';
export const titlePin = 'Validate Pin | Angellira';

export const pinMessage = 'Enter the Pin to access the system';
export const validatePin = 'Validate';

export const credentials = 'Enter your credentials to access the system';
export const clientAccess = 'requesting access to your account:';
export const passInsert = 'Enter your new password';
export const userInpersonate = 'Enter the user to impersonate';

export const user = 'User';
export const pass = 'Password';
export const passConfirmation = 'Password Confirmation';

export const passMust = 'You password must have at least:';
export const passLength = 'at least 9 and at most 15 characters';
export const passLCLetters = '1 upper-case letter';
export const passUCLetters = '1 lower-case letter';
export const passNumbers = '2 numbers';
export const passSpecial = '1 special character';
export const passConfirmationHelper = `Must be the same as in the "${pass}" field`;
// eslint-disable-next-line max-len
export const ensurePass = 'Your password could not be changed. It does not satisfy the complexity pattern or you have used it recently. Choose another.';

export const login = 'Login';
export const recover = 'Recover';
export const allow = 'Allow';
export const inpersonate = 'Inpersonate';

export const forgotten = 'Forgot my password';
export const logout = 'Log Out';

export const copyright = 'All rights reserved';

export const ecosystem = 'Angel Lira ecosystem';
export const tagline = 'Your operation, all in one place.';
export const connected = '12 connected solutions';
export const network = 'One network. One operation.';
export const noCompany = 'Your company is not registered yet?';
export const noCompanyHelp = 'Ask the platform administrator to register it.';

export const aliaNoAccess = 'You don\'t have access to <span class="alia-dialog__name">ALIA</span> yet';
export const aliaDescription = 'The first artificial intelligence built to work in logistics operations.';
export const aliaKnow = 'Discover ALIA';

export const tickerAlia = 'The Artificial Intelligence <strong>that works in your logistics operation.</strong>';
export const tickerFenatran = 'Come see it at Fenatran 2026';
export const tickerDrivers = 'Need drivers for your fleet? <strong>We have them!</strong>';

export const successes = {
  'valid-pin': 'You already have a valid pin, check your email',

  'email-pin': 'Check your email to redeem the pin',
  'email-sent': 'Check your email to recover your password',
  // eslint-disable-next-line max-len
  'pass-recovered': 'Password changed successfully! You can now login to Angellira systems using the new password!',
  'lease-sent': 'Check your e-mail to authorize the session',
  'session-allowed': 'Session authorized',
};

export const errors = {
  'missing-user': 'Please, enter User for recovery',
  'missing-email': 'You do not have a registered email',
  'missing-mimic': 'Cannot impersonate user',

  'invalid-pin': 'Invalid pin, try again',
  'expired-pin': 'This pin has already expired, please try again.',

  'invalid-user': 'Invalid User',
  'invalid-password': 'Invalid Password',
  'invalid-recover': 'Invalid Session, request a new recovery',
  'invalid-permission': 'Invalid Permission',
  'invalid-client': 'Client Not Found',
  'invalid-token': 'Invalid token',
  // eslint-disable-next-line max-len
  'invalid-company': 'Could not reach lirasys. Please, contact <a href="mailto:help@angellira.com.br">help@angellira.com.br</a>',
  'max-attempts': 'The number of attempts has been exceeded, try again in a few minutes',
  'out-until': 'You could try again at',
  // eslint-disable-next-line max-len
  'multiple-sessions': 'This user is already authenticated in another session. <a href="/session/lease">Follow this link</a> to allow another session via e-mail.',
  'no-lease': 'It\'s not possible to authorize another session.',
  'failed': 'Failed while trying to process your request. Try again later.',

  'ip-not-allowed': 'This device is not authorized to access this company.',

  'jwt-must-be-provided': 'Invalid Session, request a new recovery',
  'jwt-expired': 'Your session has expired',
  'recover-expired': 'This recovery link is expired, please request again',

  // eslint-disable-next-line max-len
  'pw-validation-error': 'Your password could not be changed. It does not satisfy the complexity pattern or you have used it recently. Choose another.',
  'pw-unconfirmed': 'The inserted passwords do not match',
  // eslint-disable-next-line max-len
  'pw-expired': 'Your password has expired. Perform the recovery process to generate a new valid password',
};
